export const getTransports = (state, transports) => {
  state.transports = transports
}

export const setLoading = (state, value) => {
  state.loading = value;
} 